import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { WareHouseDto } from "../dtos/warehouse/wareHouseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/warehouse`;

/**
 * 창고 전체 목록 조회
 * @returns 모든 창고 목록
 */
export const getAllWarehouses = async () => {
  return await getData<ResponseDto<WareHouseDto[]>>(baseUrl);
};

/**
 * 사용 가능한 창고 목록 조회
 * @returns 사용 가능한 창고 목록 (useYn = 'Y')
 */
export const getActiveWarehouses = async () => {
  return await getData<ResponseDto<WareHouseDto[]>>(`${baseUrl}/active`);
};

/**
 * 물류센터별 창고 목록 조회
 * @param logicCenter 물류센터 코드
 * @returns 해당 물류센터의 창고 목록
 */
export const getWarehousesByLogicCenter = async (logicCenter: string) => {
  return await getData<ResponseDto<WareHouseDto[]>>(`${baseUrl}/logic-center/${logicCenter}`);
};

/**
 * 물류센터별 사용 가능한 창고 목록 조회
 * @param logicCenter 물류센터 코드
 * @returns 해당 물류센터의 사용 가능한 창고 목록 (useYn = 'Y')
 */
export const getActiveWarehousesByLogicCenter = async (logicCenter: string) => {
  return await getData<ResponseDto<WareHouseDto[]>>(`${baseUrl}/logic-center/${logicCenter}/active`);
};

/**
 * @deprecated 기존 검색 함수 (하위 호환성 유지)
 * getActiveWarehouses() 사용 권장
 */
export const getWarehouseList = async (searchText: String) => {
  return await getData<ResponseDto<WareHouseDto[]>>(baseUrl, {
    params: {
      searchText
    }
  });
};

